import { Group, Radio } from "@mantine/core";

interface RadioChoice {
  label: string;
  value: string;
}

interface RadioFilterItemProps {
  choices: Array<RadioChoice>;
  radioName: string;
  filterValue: string;
  onChange: (value: string) => void;
}

function RadioFilterItem({
  choices,
  radioName,
  filterValue: value,
  onChange
}: RadioFilterItemProps) {
  return (
    // for some reason, the Radio.Group component does not work without a form element
    <form>
      <Radio.Group
        className="RadioFilterItem"
        name={radioName}
        value={value}
        onChange={onChange}
      >
        <Group>
          {choices.map((choice) => (
            <Radio
              key={choice.value}
              label={choice.label}
              value={choice.value}
            />
          ))}
        </Group>
      </Radio.Group>
    </form>
  );
}

export { RadioChoice, RadioFilterItem, RadioFilterItemProps };
